<template>
<div class="orderService">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <!--<el-tab-pane label="版本服务" name="versionService">-->
            <!--<VersionService></VersionService>-->
        <!--</el-tab-pane>-->
        <el-tab-pane label="功能服务" name="functionalService" @click="fService">
            <FunctionalService></FunctionalService>
        </el-tab-pane>
        <el-tab-pane label="订购记录" name="OrderRecordList">
            <OrderRecordList></OrderRecordList>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import VersionService from './versionService'
import FunctionalService from './functionalService'
import OrderRecordList from './orderRecord/orderRecordList'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'orderService',
    data() {
        return {
            activeName: 'functionalService'
        }
    },
    mounted() {
        if (this.$route.query.tabs) {
            this.activeName = this.$route.query.tabs
        }
        if (this.params.subAccount && this.params.subAccount.activeName) {
            this.activeName = this.params.subAccount.activeName
        } else {
            this.setParams({subAccount: {activeName: this.activeName}})
        }
        if (this.$route.params.tab) {
            this.activeName = this.$route.params.tab
        }
    },
    methods: {
        handleClick(tab, event) {
            this.setParams({activeName: tab.name})
        },

        fService() {
            this.$router.push({name: 'functionalService'})
        },

        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'params'
        ])
    },
    components: {
        VersionService,
        FunctionalService,
        OrderRecordList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.orderService {
    height: 100%;
    .el-tabs {
        .el-tabs__header {
            background: #fff;
            height: 50px;
            padding: 0 20px;
        }
    }
}
</style>
